import React from "react";
import { FormMessage } from "../../components/shared/form-message";
import { useId } from "../../hooks/use-id";

/**
 * Campo de entrada para el nombre y apellido del usuario.
 *
 * Renderiza un campo de texto para capturar el nombre completo,
 * registra el campo en React Hook Form y valida que sea obligatorio.
 * Además, muestra una descripción de ayuda y el mensaje de error
 * correspondiente cuando la validación falla.
 *
 * @component
 * @param {Object} props - Propiedades del componente.
 * @param {Object} props.formController - Instancia de React Hook Form utilizada para registrar y validar el campo.
 * @param {Object} props.texts - Objeto con los textos traducidos utilizados en la interfaz.
 *
 * @returns {JSX.Element} InstFullNameInput
 */
export const InstFullNameInput = ({ formController, texts }) => {
    const nombreYapellido = useId('nombreYapellido');

    // Identificador utilizado por React Hook Form para registrar el campo.
    const fieldFullName = 'nombreYapellido';
    
    const { institucional } = texts;
    const { form } = institucional;

    const {
        register,
        formState: { errors } } = formController

    return (
        <>
            <label
                htmlFor={nombreYapellido}
                className="secondary-item"
            >
                <strong>{form?.nombre?.label || 'Nombre y apellido*:'}</strong>
            </label>
            <p className="onbackground-third--color mm-redimir-terms">
                {form?.nombre?.descripcion || 'Escríbelos como aparecen en tu identificación'}
            </p>
            <input
                type="text"
                className="form-control focusable-secondary"
                id={nombreYapellido}
                placeholder={form?.nombre?.placeholder || "Escribe tu nombre y apellido aquí"}
                defaultValue=""
                {...register(
                    fieldFullName,
                    {
                        required: {
                            value: true,
                            message: form?.nombre?.alert || 'Debes escribir tu nombre y apellido'
                        }
                    }
                )}
            />
            <FormMessage
                message={errors[fieldFullName]?.message}
                type={"error"}
            />
        </>
    )
}